module.exports = ".row{\r\n    padding:1em 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/project-phase-details/project-phase-form/project-phase-form.component.css
// module id = ./src/app/planning/project-phase-details/project-phase-form/project-phase-form.component.css
// module chunks = main